

import { getPriceNameList } from './usePrice.js'
import { getName } from './useFast.js'

export default {
	props: {
		filter: {
			type: Object,
			requried: true
		},
		sectionOptions: {
			type: Array,
			requried: true
		}
	},
	methods: {
        getPriceNameList,
        getName,

		/**
		 * 更新价格区间输入
		 * @param type 输入类型（最小值/最大值）
		 * @param event 输入事件
		 * @param category 分类对象
		 */
		updatePriceRange(type, event, category) {
			// 价格相关字段，可以输入小数点
			if (category.mappingField?.toLocaleLowerCase().includes('price'))
				return

			const target = event.target
			if (target) {
				// 只允许数字输入
				const numValue = target.value.replace(/\D/g, '')
				category.value[type] = numValue
			}
		},

		/**
		 * 验证并修正价格区间
		 * @param category 筛选分类对象
		 */
		validatePriceRange(category) {
			const priceRange = category.value
			const min = Number(priceRange.min)
			const max = Number(priceRange.max)

			// 如果最小值大于最大值，交换它们
			if (min && max && min > max) {
				[priceRange.min, priceRange.max] = [priceRange.max, priceRange.min]
			}
			category.nameList = getPriceNameList(priceRange, getName(category))

            this.$emit('search')
		},
	}
}
